const WithdrawManage = () => import('@/pages/finance-manage/WithdrawManage');
const WithdrawDetail = () => import('@/pages/finance-manage/WithdrawDetail');
const PlatformFlow = () => import('@/pages/finance-manage/PlatformFlow');

export default[
    {
      path: '/withdraw-manage',
      component: WithdrawManage,
      meta: [
        {
          name: '财务管理',
          url: '',
        },
        {
          name: '提现管理',
          url: '',
        },
      ],
    },
    {
      path: '/withdraw-manage/withdraw-detail',
      component: WithdrawDetail,
      meta: [
        {
          name: '财务管理',
          url: '/withdraw-manage',
        },
        {
          name: '提现管理',
          url: '/withdraw-manage',
        },
        {
          name: '提现管理详情',
          url: '',
        },
      ],
    },
    {
      path: '/platform-flow',
      component: PlatformFlow,
      meta: [
        {
          name: '财务管理',
          url: '/withdraw-manage',
        },
        {
          name: '平台流水',
          url: '',
        }
      ],
    },
]
